/* AM collection view. v9:
   - Desktop default ALWAYS 4 per row on entry (no persistence). Toggles 3/4/6 (6=compact image-only).
   - Discount badge = red "N% OFF" on ALL products, desktop native grid AND mobile ss-featured.
   - Filter drawer: inject a close (X) button + Escape-to-close (Dawn hides its native close on desktop). */
(function(){
  var saved=4; /* always default to 4 columns on entry */
  function num(el){ return el ? parseFloat((el.textContent||'').replace(/[^0-9.]/g,'')) : NaN; }
  function apply(){
    var grid=document.getElementById('product-grid');
    if(grid){ grid.style.setProperty('--am-cols', saved); grid.classList.toggle('am-compact', saved===6); }
    var b=document.querySelectorAll('[data-am-switch] button');
    for(var i=0;i<b.length;i++){ b[i].classList.toggle('is-active', parseInt(b[i].dataset.cols)===saved); }
  }
  function wireToggle(){
    var b=document.querySelectorAll('[data-am-switch] button');
    for(var i=0;i<b.length;i++){ (function(x){ if(x.__w) return; x.__w=1;
      x.addEventListener('click', function(){ saved=parseInt(x.dataset.cols)||4; apply(); });
    })(b[i]); }
  }
  function wireFilter(){
    var fb=document.querySelector('[data-am-filter]'); if(!fb || fb.__f) return; fb.__f=1;
    fb.addEventListener('click', function(){ var s=document.querySelector('.mobile-facets__open-wrapper'); if(s) s.click(); });
  }
  var escWired=false;
  function ensureFacetClose(){
    var mf=document.querySelector('.mobile-facets'); if(!mf) return;
    if(!mf.querySelector('.am-facet-close')){
      var disc=mf.closest('details.mobile-facets__disclosure') || document.querySelector('details.mobile-facets__disclosure');
      var btn=document.createElement('button');
      btn.type='button'; btn.className='am-facet-close'; btn.setAttribute('aria-label','Close filters'); btn.innerHTML='&times;';
      btn.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); if(disc) disc.removeAttribute('open'); });
      mf.appendChild(btn);
    }
    if(!escWired){ escWired=true; document.addEventListener('keydown', function(e){ if(e.key==='Escape'||e.keyCode===27){ var d=document.querySelector('details.mobile-facets__disclosure[open]'); if(d) d.removeAttribute('open'); } }); }
  }
  /* Desktop native grid: red "N% OFF" badge on every discounted card. */
  function badges(){
    var grid=document.getElementById('product-grid'); if(!grid) return;
    var items=grid.querySelectorAll('.grid__item');
    for(var i=0;i<items.length;i++){ (function(li){
      if(li.querySelector('.am-pct')) return;
      var sale=num(li.querySelector('.price-item--sale'));
      var regEls=li.querySelectorAll('.price-item--regular'); var regs=[];
      for(var j=0;j<regEls.length;j++){ var v=num(regEls[j]); if(v>0) regs.push(v); }
      if(!sale || !regs.length) return;
      var reg=Math.max.apply(null, regs);
      if(sale>=reg) return;
      var p=Math.round((reg-sale)/reg*100); if(p<=0) return;
      var box=li.querySelector('.card__inner') || li.querySelector('.card__media'); if(!box) return;
      var b=document.createElement('span'); b.className='am-pct am-pct--red'; b.textContent=p+'% OFF';
      box.appendChild(b);
    })(items[i]); }
  }
  /* Mobile ss-featured: rewrite gold "-45%" badge text to red "45% OFF" (color/position via CSS). */
  function ssBadges(){
    var els=document.querySelectorAll('[id*="__grid_unified"] .am-discount-badge');
    for(var i=0;i<els.length;i++){ var el=els[i]; var m=(el.textContent||'').trim().match(/^-?(\d+)%$/); if(m){ el.textContent=m[1]+'% OFF'; } }
  }
  function all(){ try{wireToggle();}catch(e){} try{wireFilter();}catch(e){} try{ensureFacetClose();}catch(e){} try{apply();}catch(e){} try{badges();}catch(e){} try{ssBadges();}catch(e){} }
  if(document.readyState!=='loading') all(); else document.addEventListener('DOMContentLoaded', all);
  window.addEventListener('load', all);
  document.addEventListener('shopify:section:load', all);
  var sched=false;
  try{ new MutationObserver(function(){ if(sched) return; sched=true; requestAnimationFrame(function(){ sched=false; all(); }); }).observe(document.documentElement,{childList:true,subtree:true}); }catch(e){}
})();
